import { useLanguage } from '@/contexts/language-context';

import { BusinessLogoSection } from './business-logo-section';
import { CalendarSyncSection } from './calendar-sync-section';

export function BusinessPage() {
  const { t } = useLanguage();

  return (
    <div className="max-w-2xl mx-auto flex flex-col gap-6">
      <h1 className="text-xl font-semibold">{t.businessPageNav}</h1>
      <BusinessLogoSection />
      <CalendarSyncSection />
    </div>
  );
}
